// Backend base URL; set REACT_APP_BACKEND_URL (https) for production builds
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8000").replace(/\/+$/, "");
